const digest = '9b56963069c0c249b7b5d7ffe31ecefbef6576856594af543b8e2b2dc32f00df';
const css = `body,div[data-module-name=axp-hotel-booking-navigation] b,strong{font-family:Helvetica Neue,Helvetica,sans-serif}div[data-module-name=axp-hotel-booking-navigation] div[class*=container]{max-width:unset!important}div[data-module-name=axp-hotel-booking-navigation] div[class*=MobileSubNav] span[class*=programDesc]{padding-left:1.125rem}a{padding-bottom:0!important;padding-top:0!important}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default {  };

export { css, digest };